import { useQuery } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { CalendarEventModel } from '@/types/calendar';

import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

const METHOD = 'GET';
const ENDPOINT = 'calendar-events/:id';
export const QUERY_KEY = (id: number) => getQueryKey(METHOD, ENDPOINT, { id });

export const useGetCalendarEvent = (id: number, enabled = true) => {
  const { session } = useAuth();

  return useQuery({
    enabled: enabled && !!session?.access_token && !!id,
    queryKey: QUERY_KEY(id),
    queryFn: async () => {
      try {
        const data = await handleApiCall<CalendarEventModel>(
          session,
          METHOD,
          getResolvedEndpoint(ENDPOINT, {
            id: id.toString(),
          })
        );

        return data;
      } catch (err) {
        enqueueSnackbar('Failed to fetch calendar event.', { variant: 'error' });
        throw err;
      }
    },
  });
};
